import { render, staticRenderFns } from "./expense-scac-description-input.vue?vue&type=template&id=7a097f52&"
import script from "./expense-scac-description-input.vue?vue&type=script&lang=js&"
export * from "./expense-scac-description-input.vue?vue&type=script&lang=js&"
import style0 from "./expense-scac-description-input.vue?vue&type=style&index=0&id=7a097f52&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
